<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8">

  <path d="m6.99023,4.95996H1.00977c-.53027,0-.95996-.42969-.95996-.95996s.42969-.95996.95996-.95996h5.98047c.53027,0,.95996.42969.95996.95996s-.42969.95996-.95996.95996Z" fill="var(--iconPrimary, #222)"/>
  
</svg>